import { request } from '@umijs/max';

type RequestOptions = Record<string, any>;
const AUTH_TOKEN_KEY = 'trade_auto_token';

export async function authRequest<T>(url: string, options: RequestOptions = {}, token?: string) {
  const actualToken = token || localStorage.getItem(AUTH_TOKEN_KEY);
  const data = options.data;
  const headers = {
    ...(options.headers || {}),
  } as Record<string, string>;

  if (actualToken) {
    headers.Authorization = `Bearer ${actualToken}`;
  }

  return request<T>(url, {
    ...options,
    headers,
    requestType: options.requestType || (typeof FormData !== 'undefined' && data instanceof FormData ? 'form' : undefined),
  });
}
